import React from "react";
import { Type } from "@ebscois/react-component-library";
import { StyledEvidenceConclusionWrapper } from "./_.styled";

const EvidenceConclusion = ({ conclusionData }) => {
  return (
    <StyledEvidenceConclusionWrapper data-testid="evidence-summary">
      <Type marginBottom="xs" fontSize="sm" display="block" color="gray700">
        STUDY SUMMARY
      </Type>
      <Type fontFamily="secondary" fontSize="md" marginBottom="xs">
        {conclusionData}
      </Type>
    </StyledEvidenceConclusionWrapper>
  );
};

EvidenceConclusion.displayName = "EvidenceSummary";

export default EvidenceConclusion;
